import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = ["autocomplete", "id", "type", "placeholder", "value", "min", "max"]
const _hoisted_3 = {
  key: 0,
  class: "p-0 mb-1 -mt-2 text-sm text-red-400"
}

import { ref, onMounted, watch } from "vue";
	import { makeFakeID } from "@/utils";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'InputTag',
  props: {
		icon: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "Change the placeholder",
		},
		css: {
			type: String,
			default: "",
		},
		type: {
			type: String,
			default: "email",
		},
		autocomplete: {
			type: String,
			default: "off",
		},
		error: {
			type: String,
			default: "",
		},
		min: {
			type: String,
			default: "",
		},
		max: {
			type: String,
			default: "",
		},
	},
  emits: ["model"],
  setup(__props) {

	const event = new Event("input");
	const inputTag = ref<any>(null);
	const isPasswordVisible = ref(false);
	const inputTagID = ref<any>(makeFakeID(5));
	

	const props = __props;

	watch(
		() => props.value,
		() => {
			// Dispatch the INPUT event.
			if (
				(props.value != "" || props.value != undefined || props.value != null) &&
				inputTag.value != null
			) {
				inputTag.value.value = props.value;
				inputTag.value.dispatchEvent(event);
			}
		}
	);

	// Méthode pour basculer la visibilité du mot de passe
	const togglePasswordVisibility = () => {
		isPasswordVisible.value = !isPasswordVisible.value;
	};

	// Calcule dynamiquement le type d'input
	const computedInputType = () => {
		if (props.type === "password") {
			return isPasswordVisible.value ? "text" : "password";
		}
		return props.type;
	};

	onMounted(async () => {
		// Initialisation
		inputTag.value = await document.querySelector("input[id=" + inputTagID.value + "]");

		// Dispatch the INPUT event.
		if (props.value != "" || props.value != undefined || props.value != null) {
			inputTag.value.dispatchEvent(event);
		}
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
				__props.css,
				{
					'flex flex-row items-center px-4 py-2 my-2 space-x-4 bg-transparent border rounded-lg border-secondary focus-within:ring-2 focus-within:ring-secondary-700 focus-within:ring-inset': true,
				},
			])
    }, [
      (__props.icon != '')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "w-6 h-6 bg-no-repeat bg-cover",
            style: _normalizeStyle({
					backgroundImage: 'url(' + (__props.icon == '' ? '/media/icons/user-icon.svg' : __props.icon) + ')',
				})
          }, null, 4))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        autocomplete: __props.autocomplete,
        id: inputTagID.value,
        type: computedInputType(),
        class: "w-full text-white placeholder-gray-500 bg-transparent outline-none focus:outline-none autofill:bg-green-800 peer",
        placeholder: __props.placeholder,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('model', $event.target?.value))),
        value: __props.value,
        min: __props.min,
        max: __props.max
      }, null, 40, _hoisted_2),
      (__props.type === 'password')
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "w-4 h-4 bg-no-repeat bg-cover opacity-50 cursor-pointer hover:opacity-70",
            style: _normalizeStyle({
            backgroundImage: 'url(' + (isPasswordVisible.value ? '/media/icons/eye-off-icon.svg' : '/media/icons/eye-on-icon.svg') + ')',
          }),
            onClick: togglePasswordVisibility
          }, null, 4))
        : _createCommentVNode("", true)
    ], 2),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})